export default __webpack_public_path__ + "static/media/mason_thumb.45a9678b.jpg";